import dynamic from 'next/dynamic';
import { useEffect } from 'react';
import Router from 'next/router';
import { Theme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box } from '@mui/system';
import { useRouter } from 'next/router';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { setCurrentBrowseRoute } from '../../redux/slices/playerSlice';
// import Player from '../Player/Player';

const Player = dynamic(() => import('../Player/Player'), {
  ssr: false, // Disable SSR if Layout relies on browser APIs or client-only state
  loading: () => null, // Optional: fallback while Layout is loading
});

import PremiumBlocker from '../PremiumBlocker';
import BottomBar from './BottomBar';
// import MenuBar from './MenuBar';

const MenuBar = dynamic(() => import('./MenuBar'), {
  ssr: false, // Disable SSR if Layout relies on browser APIs or client-only state
  loading: () => null, // Optional: fallback while Layout is loading
});

import Notification from './Notification';
import { useUserCurrentQuery } from '../../redux/services/auth/auth.generated';
import Cookies from 'js-cookie';
import React from 'react';
import { setSentryUserFromSession } from '../../utils/setSentryUser';
import useCurrentUser from '../hooks/useCurrentUser';
import { useGetFavouritesQuery } from '../../redux/services/auth/auth.generated';
import { setFavourites } from '../../redux/slices/favouritesSlice';
import { PlaylistSong } from '../../redux/types.generated';
import LoadingOverlay from './LoadingOverlay';
import { useRouteLoading } from '../hooks/useRouteLoading';

// TODO replace with URL Pattern once firefox/safari FINALLY decides to support it

const browseRegex = /(\/ragas)|(\/instruments)|(\/artistes)|(\/browse)/;

const playerRegex = /(\/browse)|(\/prahar)|(\/favourites)/;

const navTabRegex = /(\/browse(?!\/\w+))|(\/prahar)|(\/favourites)/;

const breadcrumbRegex = /(\/ragas)|(\/instruments)|(\/artistes)|(\/playlists)/;

//bottom bar height is set here and passed as props everywhere for UI layout consistency
const bottomBarHeight = 68;

const Layout: FunctionComponent = ({ children }) => {
  const loading = useRouteLoading(300);
  const { user } = useCurrentUser();

  useEffect(() => {
    setSentryUserFromSession({
      id: user?.id,
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
    });
  }, [user]);

  const dispatch = useDispatch();
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  const userToken = Cookies.get('ragya-token');
  const { data: favData, isSuccess: favLoaded } = useGetFavouritesQuery(
    { perPage: 100, page: 1 },
    { skip: !userToken }
  );

  useEffect(() => {
    if (favLoaded && favData?.userCurrent?.favourites) {
      const serverFavouritesData = (favData?.userCurrent?.favourites?.data ??
        []) as PlaylistSong[];
      dispatch(setFavourites(serverFavouritesData));
    }
  }, [favLoaded, favData, dispatch]);
  const { data } = useUserCurrentQuery({}, { skip: !userToken });

  const router = useRouter();

  const isPlayerRoute = playerRegex.test(router.asPath);

  const isBrowseRoute = browseRegex.test(router.asPath);
  const isBreadcrumbRoute = breadcrumbRegex.test(router.asPath);
  const isNavTabRoute = navTabRegex.test(router.asPath);

  const isUserPremium = data?.userCurrent.activeSubscription?.id;

  let premiumPopUpOcclusionMargin = 48;
  if (!isUserPremium) {
    premiumPopUpOcclusionMargin = 48; //made 48 from 81 to for unlock feature update
  }

  if (isBrowseRoute) {
    dispatch(setCurrentBrowseRoute({ currentBrowseRoute: router.asPath }));
  }

  return (
    <>
      {/* full-page loading overlay */}
      <LoadingOverlay loading={loading} />
      <Box>
        <MenuBar
          breakpoint={isDesktop}
          showNavTabs={isNavTabRoute}
          showBreadcrumbs={isBreadcrumbRoute}
        />
        <Box
          component={'main'}
          sx={{
            // TODO there HAS to be a more elegant way
            // set margin-top to height of menubar to prevent overlap
            mt: `${premiumPopUpOcclusionMargin}px`,
            pb: isDesktop ? 0 : `${bottomBarHeight}px`,
          }}
        >
          {children}
          {isPlayerRoute && (
            <Player bottomBarHeight={isDesktop ? 0 : bottomBarHeight} />
          )}

          {isPlayerRoute && <Box height={isDesktop ? 76 : bottomBarHeight} />}
          <Notification />
          <PremiumBlocker />
        </Box>
        {isPlayerRoute && !isDesktop && <BottomBar height={bottomBarHeight} />}
      </Box>
    </>
  );
};

export default Layout;
